import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// App
import App from './App';
// Styles
import './styles/index.css';
import './styles/components.css';
import './styles/animations.css';
import './styles/backgrounds.css';
import './styles/fonts.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
      <App />
  </BrowserRouter>
);
